import styles from "Styles/developers.module.scss";

type InfoCardProps = {
  titulo: string;
  children: React.HTMLAttributes<HTMLElement>;
};

const InfoCard: React.FC<InfoCardProps> = ({ titulo, children }) => {
  return (
    <div
      title='infoCard'
      className={`${styles.animateBig} rounded shadow  p-0 col mx-1`}>
      <div className='bg-info rounded-top m-0 py-1 col-12'>
        <p title='titulo' className={`${styles.titles} text-center mb-1`}>
          {titulo}
        </p>
      </div>
      <div className='p-2'>{children}</div>
    </div>
  );
};

export default InfoCard;
